import { createFileRoute } from '@tanstack/react-router';
import { UnifiedFormBuilderPage } from '@/components/forms-engine/UnifiedFormBuilderPage';
import type { FormSurface } from '@/types/formsEngine';

export const Route = createFileRoute('/_dashboard/dashboard/settings/appointment-forms/new')({
  validateSearch: (search: Record<string, unknown>) => ({
    surface: isFormSurface(search.surface) ? search.surface : ('VISIT_FORM' as FormSurface),
  }),
  component: NewAppointmentFormPage,
});

function NewAppointmentFormPage() {
  const { surface } = Route.useSearch();
  return <UnifiedFormBuilderPage mode="create" surface={surface} />;
}

function isFormSurface(value: unknown): value is FormSurface {
  return (
    value === 'CHECKLIST' || value === 'VISIT_FORM' || value === 'BOOKING' || value === 'INTAKE'
  );
}
